import { render, staticRenderFns } from "./PoultryHousesOverview.vue?vue&type=template&id=0e9c8d5e&"
import script from "./PoultryHousesOverview.vue?vue&type=script&lang=js&"
export * from "./PoultryHousesOverview.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHousesOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports